// Modern subtle shadows — inspired by shadcn/Vercel aesthetic
// Key difference: much lower opacity, larger blur, no hard 1px outlines
const shadows = [
  "none",
  "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  "0 1px 3px 0 rgb(0 0 0 / 0.07), 0 1px 2px -1px rgb(0 0 0 / 0.07)",
  "0 2px 4px -1px rgb(0 0 0 / 0.06), 0 1px 3px 0 rgb(0 0 0 / 0.05)",
  "0 4px 6px -2px rgb(0 0 0 / 0.05), 0 2px 4px -1px rgb(0 0 0 / 0.04)",
  "0 4px 8px -2px rgb(0 0 0 / 0.06), 0 2px 4px -1px rgb(0 0 0 / 0.04)",
  "0 6px 10px -3px rgb(0 0 0 / 0.06), 0 2px 4px -1px rgb(0 0 0 / 0.04)",
  "0 8px 14px -3px rgb(0 0 0 / 0.06), 0 3px 6px -2px rgb(0 0 0 / 0.04)",
  "0 10px 20px -4px rgb(0 0 0 / 0.06), 0 4px 8px -2px rgb(0 0 0 / 0.03)",
  "0 12px 24px -4px rgb(0 0 0 / 0.06), 0 4px 8px -2px rgb(0 0 0 / 0.03)",
  "0 14px 28px -6px rgb(0 0 0 / 0.07), 0 6px 10px -3px rgb(0 0 0 / 0.03)",
  "0 16px 32px -6px rgb(0 0 0 / 0.07), 0 6px 12px -3px rgb(0 0 0 / 0.03)",
  "0 18px 36px -8px rgb(0 0 0 / 0.07), 0 8px 14px -4px rgb(0 0 0 / 0.03)",
  "0 20px 40px -8px rgb(0 0 0 / 0.07), 0 8px 16px -4px rgb(0 0 0 / 0.03)",
  "0 22px 44px -8px rgb(0 0 0 / 0.08), 0 10px 18px -4px rgb(0 0 0 / 0.03)",
  "0 24px 48px -10px rgb(0 0 0 / 0.08), 0 10px 20px -5px rgb(0 0 0 / 0.03)",
  "0 26px 50px -10px rgb(0 0 0 / 0.08), 0 12px 22px -5px rgb(0 0 0 / 0.03)",
  "0 28px 54px -12px rgb(0 0 0 / 0.08), 0 12px 24px -6px rgb(0 0 0 / 0.03)",
  "0 30px 58px -12px rgb(0 0 0 / 0.09), 0 14px 26px -6px rgb(0 0 0 / 0.03)",
  "0 32px 62px -14px rgb(0 0 0 / 0.09), 0 14px 28px -6px rgb(0 0 0 / 0.03)",
  "0 34px 66px -14px rgb(0 0 0 / 0.09), 0 16px 30px -8px rgb(0 0 0 / 0.03)",
  "0 36px 70px -16px rgb(0 0 0 / 0.10), 0 16px 32px -8px rgb(0 0 0 / 0.03)",
  "0 38px 74px -16px rgb(0 0 0 / 0.10), 0 18px 34px -8px rgb(0 0 0 / 0.03)",
  "0 40px 78px -18px rgb(0 0 0 / 0.10), 0 18px 36px -10px rgb(0 0 0 / 0.03)",
  "0 42px 82px -18px rgb(0 0 0 / 0.10), 0 20px 38px -10px rgb(0 0 0 / 0.03)",
];

// Dark mode: near-zero shadows — rely on surface color contrast instead
const darkshadows = [
  "none",
  "0 1px 2px 0 rgb(0 0 0 / 0.15)",
  "0 1px 3px 0 rgb(0 0 0 / 0.18), 0 1px 2px -1px rgb(0 0 0 / 0.15)",
  "0 2px 4px -1px rgb(0 0 0 / 0.16), 0 1px 3px 0 rgb(0 0 0 / 0.12)",
  "0 4px 6px -2px rgb(0 0 0 / 0.14), 0 2px 4px -1px rgb(0 0 0 / 0.10)",
  "0 4px 8px -2px rgb(0 0 0 / 0.15), 0 2px 4px -1px rgb(0 0 0 / 0.10)",
  "0 6px 10px -3px rgb(0 0 0 / 0.15), 0 2px 4px -1px rgb(0 0 0 / 0.10)",
  "0 8px 14px -3px rgb(0 0 0 / 0.15), 0 3px 6px -2px rgb(0 0 0 / 0.08)",
  "0 10px 20px -4px rgb(0 0 0 / 0.15), 0 4px 8px -2px rgb(0 0 0 / 0.06)",
  "0 12px 24px -4px rgb(0 0 0 / 0.15), 0 4px 8px -2px rgb(0 0 0 / 0.06)",
  "0 14px 28px -6px rgb(0 0 0 / 0.16), 0 6px 10px -3px rgb(0 0 0 / 0.06)",
  "0 16px 32px -6px rgb(0 0 0 / 0.16), 0 6px 12px -3px rgb(0 0 0 / 0.06)",
  "0 18px 36px -8px rgb(0 0 0 / 0.16), 0 8px 14px -4px rgb(0 0 0 / 0.06)",
  "0 20px 40px -8px rgb(0 0 0 / 0.16), 0 8px 16px -4px rgb(0 0 0 / 0.06)",
  "0 22px 44px -8px rgb(0 0 0 / 0.18), 0 10px 18px -4px rgb(0 0 0 / 0.06)",
  "0 24px 48px -10px rgb(0 0 0 / 0.18), 0 10px 20px -5px rgb(0 0 0 / 0.06)",
  "0 26px 50px -10px rgb(0 0 0 / 0.18), 0 12px 22px -5px rgb(0 0 0 / 0.06)",
  "0 28px 54px -12px rgb(0 0 0 / 0.18), 0 12px 24px -6px rgb(0 0 0 / 0.06)",
  "0 30px 58px -12px rgb(0 0 0 / 0.20), 0 14px 26px -6px rgb(0 0 0 / 0.06)",
  "0 32px 62px -14px rgb(0 0 0 / 0.20), 0 14px 28px -6px rgb(0 0 0 / 0.06)",
  "0 34px 66px -14px rgb(0 0 0 / 0.20), 0 16px 30px -8px rgb(0 0 0 / 0.06)",
  "0 36px 70px -16px rgb(0 0 0 / 0.22), 0 16px 32px -8px rgb(0 0 0 / 0.06)",
  "0 38px 74px -16px rgb(0 0 0 / 0.22), 0 18px 34px -8px rgb(0 0 0 / 0.06)",
  "0 40px 78px -18px rgb(0 0 0 / 0.22), 0 18px 36px -10px rgb(0 0 0 / 0.06)",
  "0 42px 82px -18px rgb(0 0 0 / 0.22), 0 20px 38px -10px rgb(0 0 0 / 0.06)",
];

export { shadows, darkshadows };
